import { useEffect } from 'react';
import { pushToDataLayer, GTMEvent } from '../utils/gtm';

export const usePageView = (eventName: GTMEvent): void => {
  useEffect(() => {
    pushToDataLayer(eventName);
  }, [eventName]);
};
